var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "interviewProgressModal",
        tabindex: "-1",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "div",
                  { staticClass: "evaluation-person-info" },
                  [
                    _c("div", [
                      _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                      _c("div", [_vm._v(_vm._s(_vm.recordList.Interviewee))]),
                    ]),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("面談日期"),
                        ]),
                        _vm._l(
                          _vm.recordList.InterviewDateList,
                          function (date, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$common.dateTimeFormatter(date)) +
                                  " "
                              ),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._l(_vm.recordList.Scores, function (score) {
                      return _c("div", { key: score.Seq }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(score.Name)),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(score.OriginScore) +
                              "/" +
                              _vm._s(score.Score)
                          ),
                        ]),
                      ])
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          right: "5px",
                          bottom: "2px",
                          color: "#ffffff",
                          "z-index": "2",
                          "font-size": "0.9em",
                        },
                      },
                      [
                        _vm._v(
                          " 最後更新者：" +
                            _vm._s(_vm.recordList.UpdateUser) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
                _vm.recordList.InterviewRecords &&
                _vm.recordList.InterviewRecords.length > 0
                  ? [
                      _c(
                        "div",
                        {
                          staticStyle: { display: "flex", "margin-top": "2px" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "evaluation-body fixed" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "evaluation-name",
                                  staticStyle: {
                                    height: "60px",
                                    "line-height": "50px",
                                  },
                                },
                                [_vm._v(" 單位面試主管 ")]
                              ),
                              _vm._l(
                                _vm.recordList.InterviewRecords[0]
                                  .InterviewRecordAppraisals,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "evaluation-field",
                                    },
                                    [_vm._v(" " + _vm._s(item.Name) + " ")]
                                  )
                                }
                              ),
                              _vm.recordList.ResumeType === "IDL"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "evaluation-field" },
                                      [_vm._v("職等")]
                                    ),
                                  ]
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "evaluation-field",
                                  staticStyle: {
                                    height: "150px",
                                    "overflow-y": "auto",
                                  },
                                },
                                [_vm._v(" 面談說明 ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "evaluation-field",
                                  staticStyle: {
                                    height: "150px",
                                    "overflow-y": "auto",
                                  },
                                },
                                [_vm._v(" 個人備註 ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "evaluation-field",
                                  staticStyle: {
                                    "border-bottom": "0.1px solid",
                                    "border-bottom-color": "#dfdfdf",
                                  },
                                },
                                [_vm._v(" 面談結果 ")]
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticStyle: { flex: "1", "min-width": "1px" } },
                            [
                              _c(
                                "carousel",
                                {
                                  key: Math.random(),
                                  attrs: {
                                    items:
                                      _vm.recordList.InterviewRecords.length,
                                    nav: true,
                                    dots: false,
                                  },
                                },
                                _vm._l(
                                  _vm.recordList.InterviewRecords,
                                  function (record) {
                                    return _c(
                                      "div",
                                      {
                                        key: record.InterviewSupervisorId,
                                        staticClass: "evaluation-body",
                                        on: {
                                          dblclick: function ($event) {
                                            return _vm.$common.copyText($event)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "evaluation-name",
                                            staticStyle: { height: "60px" },
                                          },
                                          [
                                            _vm._v(
                                              " 【" +
                                                _vm._s(record.InterviewTitle) +
                                                "】"
                                            ),
                                            _c("br"),
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    record.InterviewSupervisor +
                                                    " (" +
                                                    record.InterviewUserType +
                                                    ")",
                                                  placement: "right",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.InterviewSupervisor
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        record.InterviewUserType
                                                      ) +
                                                      ") "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(
                                          record.InterviewRecordAppraisals,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "evaluation-field",
                                              },
                                              [
                                                item.Result !== "-" &&
                                                item.Result !== "未填寫"
                                                  ? [
                                                      item.Remark
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  item.Remark,
                                                                placement:
                                                                  "right",
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.Result
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.Result
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.Result)
                                                      ),
                                                    ]),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        _vm.recordList.ResumeType === "IDL"
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evaluation-field",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.ExpectedJobLevel
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "evaluation-field",
                                            staticStyle: {
                                              height: "150px",
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(record.Remark) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "evaluation-field",
                                            staticStyle: {
                                              height: "150px",
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    record.PersonalRemark
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "evaluation-field",
                                            staticStyle: {
                                              "border-bottom": "0.1px solid",
                                              "border-bottom-color": "#dfdfdf",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    record.InterviewResult
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._m(1),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("面談紀錄歷程")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }